import type { TFunction } from "i18next";
import { formatDate } from "@/core/utils";

export const formatMonthLabel = (
  dateString: string,
  isFull: boolean = false,
  t?: TFunction,
): string => {
  if (!dateString) {
    return "";
  }

  if (dateString.length === 10) {
    return formatDate(dateString).split("/").slice(0, 2).join("/");
  }

  const [, month] = dateString.split("-");

  const monthKeys = {
    "01": "january",
    "02": "february",
    "03": "march",
    "04": "april",
    "05": "may",
    "06": "june",
    "07": "july",
    "08": "august",
    "09": "september",
    "10": "october",
    "11": "november",
    "12": "december",
  };

  const monthKey = monthKeys[month as keyof typeof monthKeys];

  if (!monthKey) {
    return dateString;
  }

  const translationKey = isFull
    ? `dashboard-month-${monthKey}`
    : `dashboard-month-${monthKey}-short`;
  return t?.(translationKey, { defaultValue: dateString }) || dateString;
};
